// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Battle_navigation__AX3Gn","repeatBTN":"Battle_repeatBTN__30L3j"};